import dayjs from "dayjs";
import { checkUserPermissionFunc } from "../../../components/common/CommonFunctions";

export const MAX_BACKDATE_DAYS = 31;

export const apiErrorMessage = (res, fallback = "Something went wrong") => {
    if (!res) return fallback;
    if (typeof res === "string") return res;
    if (res.message) return res.message;
    if (res.detail) {
        return Array.isArray(res.detail) ? res.detail.join(", ") : String(res.detail);
    }
    return fallback;
};

export const disableShiftChangeDate = (current) =>
    !current
    || current.isAfter(dayjs().endOf("day"))
    || current.isBefore(dayjs().subtract(MAX_BACKDATE_DAYS, "day").startOf("day"));

export const canSubmitShiftChangeRequest = () => {
    const isAdmin = JSON.parse(sessionStorage.getItem("is_admin") || "false");
    const isSuperAdmin = JSON.parse(sessionStorage.getItem("is_super_admin") || "false");
    const { add: addPermission } = checkUserPermissionFunc("attendance", "Shift Change Requests", "SubMenu");
    return Boolean(addPermission || isAdmin || isSuperAdmin);
};

export const canReviewShiftChangeRequests = () => {
    const isAdmin = JSON.parse(sessionStorage.getItem("is_admin") || "false");
    const isSuperAdmin = JSON.parse(sessionStorage.getItem("is_super_admin") || "false");
    const { permission: viewPermission } = checkUserPermissionFunc("attendance", "Shift Change Requests", "SubMenu");
    return Boolean(isAdmin || isSuperAdmin || viewPermission);
};

export const canViewMyShiftChangeRequests = () => {
    return canSubmitShiftChangeRequest() || canReviewShiftChangeRequests();
};

export const buildShiftOptionLabel = (shift) =>
    `${shift.shift_name || shift.name} (${shift.shift_timings_from || shift.Start_timing || ""}-${shift.shift_timings_to || shift.end_timing || ""})`;

export const formatShiftTimeRange = (shiftIn, shiftOut) => {
    if (!shiftIn && !shiftOut) return null;
    const fmt = (iso) => (iso ? dayjs(iso).format("h:mm A") : "—");
    return `${fmt(shiftIn)} – ${fmt(shiftOut)}`;
};
